export type HubKey = 'forms' | 'designs' | 'links' | 'stock'

export const isLeaveForHubConfirmed = (hubKey: HubKey): boolean => {
  try {
    return sessionStorage.getItem(`leaveForHubConfirmed_${hubKey}`) === 'true'
  } catch {
    return false
  }
}

export const setLeaveForHubConfirmed = (hubKey: HubKey, confirmed = true): void => {
  try {
    if (confirmed) {
      sessionStorage.setItem(`leaveForHubConfirmed_${hubKey}`, 'true')
    } else {
      sessionStorage.removeItem(`leaveForHubConfirmed_${hubKey}`)
    }
  } catch {
    // Ignore sessionStorage quota / privacy errors
  }
}
